import React from 'react';
import { formatDateRangeJewish, formatDateJewish } from '../../utils/dateUtils';
import { renderKioskScheduleSection } from '../../utils/scheduleRenderer';
import parse from 'html-react-parser';
import { bidiText } from '../../utils/bidiText';
import WeeklyPrintSchedule from './WeeklyPrintSchedule';

/**
 * Component for displaying the print schedule section
 * @param {Object} props - Component props
 * @param {Object} props.printSchedule - Print schedule data
 * @param {string} props.announcements - Announcements HTML
 * @param {Array} props.weeklyNotices - Weekly notices
 * @param {Function} props.reloadWithNextSaturday - Function to reload with next Saturday
 */
function PrintScheduleSection({ printSchedule, announcements, weeklyNotices, reloadWithNextSaturday, isPrintPreview = false }) {
  if (!printSchedule) {
    return null;
  }

  if (isPrintPreview) {
    return (
      <WeeklyPrintSchedule
        printSchedule={printSchedule}
        announcements={announcements}
        weeklyNotices={weeklyNotices}
        reloadWithNextSaturday={reloadWithNextSaturday}
      />
    );
  }

  return (
    <div className="print-schedule-container">
      {/* ----- Print Version: Only visible when printing ----- */}
      <div className="top-right-header">בס"ד</div>
      <div 
        className="visible-screen-hidden-print next-week-print" 
        onClick={(e) => { 
          e.preventDefault(); 
          reloadWithNextSaturday(); 
        }}
      >
        Next Week Schedule
      </div>
      <div className="print-header">
        <div className="branding">
          <img src="/logo.png" alt="BLY Logo" /> Beis Levi Yitzchok
        </div>
        <div className="parsha">{printSchedule.parsha}{printSchedule.chazak ? ' - חזק' : ''}</div>
      </div>
      {printSchedule && printSchedule.dateRange && (
        <div className="date-range" style={{display: 'flex', justifyContent: 'space-between'}}>
          <div>
            שבוע של {formatDateRangeJewish(
              new Date(new Date(printSchedule.dateRange.start).getTime() + 24 * 60 * 60 * 1000), 
              printSchedule.dateRange.end
            )}
          </div>
          <div>
            {printSchedule.mevorchim ? 'שבת מברכים' : 'שבת'} {formatDateJewish(printSchedule.dateRange.start)}
          </div>
        </div>
      )}

      <div className="print-schedule">
        {renderKioskScheduleSection(printSchedule, 'fridayNight')}
        {renderKioskScheduleSection(printSchedule, 'shabbosDay')}
        {renderKioskScheduleSection(printSchedule, 'shabbosAfternoon')}
        {renderKioskScheduleSection(printSchedule, 'sunday')}
        {renderKioskScheduleSection(printSchedule, 'weekdays')}
      </div>
      
      <div className="print-footer">
        {announcements && (
          <section className="announcements">
            {parse(announcements)}
          </section>
        )}

        <section className="weekly-notices">
          <h2 className="heading">Notices</h2>
          <div id="notices-content">
            {weeklyNotices.map((notice, index) => (
              <li dir="rtl" key={index}>{bidiText(notice)}</li>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}


export default PrintScheduleSection;
